import { isPlaceholderPhone } from "@/lib/labs/format";

/** Chiffres au format national : « +212528852426 » et « 0528852426 » sont un seul numéro. */
export function phoneKey(phone: string): string {
  return phone.replace(/\D/g, "").replace(/^00/, "").replace(/^212/, "0");
}

/** Numéro renseigné et non factice (« 05 22 00 00 00 »…). */
function usablePhone(phone: string | null | undefined): string | null {
  const value = (phone ?? "").trim();
  return value.length >= 8 && !isPlaceholderPhone(value) ? value : null;
}

/**
 * Numéro marocain au format national (05 à 08 suivi de 8 chiffres) : 63 numéros
 * du catalogue n'y sont pas (+213, +33, chiffre manquant) et pouvaient figurer
 * parmi les « joignables » d'une ville marocaine (2026-10-05).
 */
export function reachablePhone(phone: string | null | undefined): string | null {
  const value = usablePhone(phone);
  return value !== null && /^0[5-8]\d{8}$/.test(phoneKey(value)) ? value : null;
}

/**
 * Numéro qu'une fiche peut proposer d'appeler : marocain (reachablePhone) ou
 * étranger écrit avec son indicatif (« +33 6 86 87 22 46 »). Les 44 numéros du
 * catalogue qui ne sont ni l'un ni l'autre (« 5234778899 » à motif du scraping
 * smartdoc, « 01… » français, 9 chiffres) s'affichaient en « Appeler le
 * cabinet » sur un lien tel: qui ne passe pas (2026-10-05).
 */
export function callablePhone(phone: string | null | undefined): string | null {
  const national = reachablePhone(phone);
  if (national !== null) return national;
  const value = usablePhone(phone);
  return value !== null && /^\+(?!212)\d{8,14}$/.test(value.replace(/\s/g, "")) ? value : null;
}
